import { Action } from 'redux';
import * as shallowEqual from 'shallowequal';
import * as _ from 'underscore';

import { isSetCollectionVisibility } from '~src/app/actions/spaces/Collections/SetCollectionVisibilityAction';

import { isFilterContentTypeAction } from '../../actions/spaces/ContentExplorerFilterActions';
import { isEnterSpaceAction, isSetSpaceInfoItemAction } from '../../actions/spaces/EnterSpaceAction';
import { isSiteSpace, isWorkbookSpace, SpaceInfo } from '../../state/SpaceInfo';

export const InitialState: SpaceInfo = {
  item: undefined,
  spaceType: undefined,
  subspaceName: undefined
};

export function spaceInfoReducer(
  previousState: SpaceInfo = InitialState,
  action: Action
): SpaceInfo  {

  if (isEnterSpaceAction(action)) {
    const newState: SpaceInfo = {
      item: action.item,
      spaceType: action.spaceType,
      subspaceName: action.subspaceName
    };

    return _.isEqual(newState, previousState) ? previousState : newState;
    //return shallowEqual(newState, previousState) && shallowEqual(newState.item, previousState.item) ? previousState : newState;
  }

  if (isSetSpaceInfoItemAction(action)) {
    // just update the item if we are in the same space otherwise
    if (previousState.spaceType === action.spaceType) {
      return {...previousState, item: action.item};
    }
  }

  if (isSetCollectionVisibility(action)) {
    if (previousState.spaceType === 'collection') {
      const contentId = _.find(action.contentIds, contentId => contentId === previousState.item.id);
      if (contentId) {
        const newItem = {...previousState.item, visibility: action.visibility};
        return {...previousState, item: newItem};
      }
    }
    return previousState;
  }

  // We need to listen to filter content type action to catch
  // datasources <-> dataconnection changes.  Since dataconnection is
  // set using the contentType query param
  if (isFilterContentTypeAction(action) && action.contentTypes.length === 1) {
    const newState: SpaceInfo = {
      item: previousState.item,
      spaceType: previousState.spaceType,
      subspaceName: previousState.subspaceName
    };
    if (isWorkbookSpace(previousState)) {
      if (action.contentTypes[0] === 'dataconnection') {
        newState.subspaceName = 'dataconnections';
      } else if (action.contentTypes[0] === 'datasource'){
        newState.subspaceName = 'datasources';
      }
    }

    if (isSiteSpace(previousState)) {
      if (previousState.subspaceName === 'dataconnection' || previousState.subspaceName === 'datasource') {
        if (action.contentTypes[0] === 'dataconnection') {
          newState.subspaceName = 'dataconnection';
        } else if (action.contentTypes[0] === 'datasource'){
          newState.subspaceName = 'datasource';
        }
      }
    }
    return shallowEqual(newState, previousState) ? previousState : newState;
  }

  return previousState;
}
